import { useRouter } from '@abyss/web/hooks/useRouter';
import { usePageTitleStore } from '@src/store/common/PageTitleStore';
import { PageTitle } from './PageTitleType';

const PageTitleService = () => {
  const { getRouteParams } = useRouter();
  const params = getRouteParams('');
  const setPageTitle = usePageTitleStore((state) => state.setPageTitle);

  const UpdatePageTitle = async (data: PageTitle) => {
    let element = structuredClone(data);
    let title = element.title;
    if (element.prefix) {
      title = `${element.prefix} ${title}`;
    }
    if (element.suffix) {
      title = `${title} ${element.suffix}`;
    }
    if (element.prefixedAddEditLabel && params.id) {
      title =
        (~~params.id > 0
          ? element.prefixedAddEditLabel.Edit
          : element.prefixedAddEditLabel.Add) +
        ' ' +
        title;
    }
    element.title = title;
    await setPageTitle(element);
  };

  return { UpdatePageTitle };
};

export { PageTitleService };
